var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAddOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V8M12 8V10M12 8H14M12 8H10M8.66667 4.66667C8.66667 5.37391 8.38572 6.05219 7.88562 6.55229C7.38552 7.05238 6.70724 7.33333 6 7.33333C5.29276 7.33333 4.61448 7.05238 4.11438 6.55229C3.61428 6.05219 3.33333 5.37391 3.33333 4.66667C3.33333 3.95942 3.61428 3.28115 4.11438 2.78105C4.61448 2.28095 5.29276 2 6 2C6.70724 2 7.38552 2.28095 7.88562 2.78105C8.38572 3.28115 8.66667 3.95942 8.66667 4.66667ZM2 13.3333C2 12.2725 2.42143 11.2551 3.17157 10.5049C3.92172 9.75476 4.93913 9.33333 6 9.33333C7.06087 9.33333 8.07828 9.75476 8.82843 10.5049C9.57857 11.2551 10 12.2725 10 13.3333V14H2V13.3333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddOutline);
export default __webpack_public_path__ + "static/media/UserAddOutline.7b757dfcc246ef59679579119b642b2d.svg";
export { ForwardRef as ReactComponent };